"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAP_ID = exports.MAP_CONFIGS = void 0;
const map_1 = require("../../../../types/map");
const mapStyles_1 = __importDefault(require("./mapStyles"));
exports.MAP_CONFIGS = [
    {
        id: "map",
        label: "Map",
        mapTypeId: map_1.MapTypeId.ROADMAP,
        mapId: "3808fe50f232092d",
        styles: mapStyles_1.default,
    },
    {
        id: "satellite",
        label: "Satellite",
        mapTypeId: map_1.MapTypeId.SATELLITE,
    },
    {
        id: "terrain",
        label: "Terrain",
        mapTypeId: map_1.MapTypeId.TERRAIN,
    },
    {
        id: "labels",
        label: "Labels",
        mapTypeId: map_1.MapTypeId.HYBRID,
    },
];
exports.MAP_ID = "3808fe50f232092d";
